import Swal from "sweetalert2";

export const Validardocumento = (state) => {
  if (state === undefined || state === null) {
    Swal.fire(
      "Clientes",
      "Error interno favor de actualizar la aplicación",
      "error"
    );
    return false;
  }
  if (
    state.documento === undefined ||
    state.documento === null ||
    state.documento.length === 0
  ) {
    Swal.fire("Clientes", "El documento es obligatorio", "error");
    return false;
  }
  if (
    state.vencimiento === undefined ||
    state.vencimiento === null ||
    state.vencimiento.length === 0
  ) {
    Swal.fire("Clientes", "El vencimiento es obligatorio", "error");
    return false;
  }
  return {
    idclientedocumento: -1,
    idcliente: -1,
    iddocumento: -1,
    orden: -1,
    documento: state.documento,
    extension: state.extension,
    vigencia: state.vencimiento,
    comentarios: state.comentarios,
    estatus: state.estatus,
  };
};
